import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Box, useTheme, Button, InputBase, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import { getDatos } from "../../services/garden.services";
import { format } from "date-fns";
import SearchIcon from "@mui/icons-material/Search";
import ModalEditWors from "../../modal/garden/modalEditWork";
import { getResumenView } from "../../services/marcaciones.services";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateField } from "@mui/x-date-pickers/DateField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import * as React from "react";
import dayjs from "dayjs";
import ModalCharge from "../../modal/modalCharge";
import CustomToolbar from "../../utils/CustomToolbar";
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { getPagoAdelantoView } from "../../services/pagos.services";

const ResumenAdelanto = () => {
  const [data, setData] = useState([]);
  const [modalDialogo, setModalDialogo] = useState(false);
  const [activeButton, setActiveButton] = useState(false);
  const [modalEditWorks, setModalEditWorks] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectedWorks, setSelectedWorks] = useState(null);
  const [value, setValue] = React.useState(dayjs());
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [originalData, setOriginalData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: "id", headerName: "ID" },
    {
      field: "nombre",
      headerName: "NOMBRE",
      flex: 2,
      cellClassName: "name-column--cell",
    },
    {
      field: "cedula",
      headerName: "CEDULA",
      flex: 2,
      cellClassName: "name-column--cell",
    },
    {
      field: "grupo",
      headerName: "GRUPO",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "adelanto",
      headerName: "Adelanto",
      flex: 1,
      cellClassName: "name-column--cell",
  
    },

  ];
  useEffect(() => {
    // Activa el estado de carga a 'true'
    setIsLoading(true);

    // Después de 3 segundos, cambia el estado a 'false'
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    // Limpia el temporizador en caso de que el componente se desmonte
    return () => clearTimeout(timer);
  }, []);

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);
  };

  const handleRowSelection = (newSelection) => {
    if (newSelection.length === 0) {
      setSelectedWorks(null);
      setSelectedRowIds([]);
      setActiveButton(false);
    } else {
      const selectedRowId = newSelection[newSelection.length - 1];
      setSelectedRowIds([selectedRowId]);
      const selectedRow = data.find((row) => row.Id === selectedRowId);
      setSelectedWorks(selectedRow.Id);
      setActiveButton(true);
    }
  };
  
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const datos = await getPagoAdelantoView();
        setData(datos);          // <-- Add this line
        setFilteredData(datos);  // Initialize filtered data with full dataset
      } catch (error) {
        console.error("Error al obtener datos del backend:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!searchValue.trim()) {
      setFilteredData(data);
    } else {
      const filtered = data.filter((item) =>
        item.nombre.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchValue, data]);



  const calcularCantidad = () => {
    return filteredData.reduce((acc, curr) => {
      // Asegurarse que el valor sea numérico
      const cantidad = parseFloat(curr.adelanto) || 0;
      return acc + cantidad;
    }, 0);
    
  };




const handleExport = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Resumen');

  // Definir columnas
  worksheet.columns = [
    { header: 'Nombre y Apellido', key: 'nombre', width: 25 },
    { header: 'Cédula', key: 'cedula', width: 15 },
    { header: 'Sector', key: 'grupo', width: 20 },
    { header: 'Adelanto', key: 'adelanto', width: 18 },
  ];

  // Preparar los datos
  const exportableData = filteredData.map((row) => {
    const nombre = row?.nombre || row?.Funcionario || "";
    const grupo = row?.grupo || "";
    const cedula = row?.cedula ? Number(row.cedula).toLocaleString('es-ES') : "";
    const adelanto = row?.adelanto ? Number(row.adelanto) : 0;

    return { nombre, cedula, grupo, adelanto };
  });

  // Agregar las filas principales
  worksheet.addRows(
    exportableData.map((item) => ({
      ...item,
      adelanto: item.adelanto.toLocaleString('es-ES'),
    }))
  );

  // Estilos cabecera
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFF' } };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '143f04' },
    };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // Bordes de las filas
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber !== 1) {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    }
  });

  // Calcular total y resumen por monto
  const totalAdelanto = exportableData.reduce((acc, curr) => acc + curr.adelanto, 0);
  const cantidadFuncionarios = exportableData.length;

  // Agrupar por monto
  const agrupado = exportableData.reduce((acc, curr) => {
    const monto = curr.adelanto;
    acc[monto] = (acc[monto] || 0) + 1;
    return acc;
  }, {});

  const resumenInicio = worksheet.rowCount + 2;
  worksheet.addRow([]);
  worksheet.addRow(["", "RESUMEN GENERAL"]);
  worksheet.addRow(["Cantidad de funcionarios:", cantidadFuncionarios]);
  worksheet.addRow(["Total adelantos:", totalAdelanto.toLocaleString('es-ES')]);

  worksheet.addRow([]);
  worksheet.addRow(["Monto", "Cantidad de funcionarios"]);
  Object.entries(agrupado).forEach(([monto, count]) => {
    worksheet.addRow([Number(monto).toLocaleString('es-ES'), count]);
  });

  // Aplicar estilo al título del resumen
  worksheet.getRow(resumenInicio + 1).font = { bold: true, size: 13, color: { argb: '143f04' } };

  // Descargar archivo
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'Resumen_Adelanto.xlsx';
  link.click();
};




  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" p={0}>
        <Header
          title="Resumen de Pagos"
          subtitle="Resumen de Pagos"
        />
        <Box display="flex" alignItems="center">
  <Box sx={{
    marginRight:"2%",
    marginLeft:"2%",

  }}>
              
              <Button sx={{
                background:"#143f04",
                width:"100%",
                height:"3rem!important",
                color:"white",
                borderRadius:"8px", "&:hover": {
                  background: "#36a60f", // Color de fondo cuando el botón está en hover
                },
                
              }} onClick={handleExport} variant="contained" color="primary">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/732/732220.png"
                  alt="Excel Icon"
                  style={{ width: 24, height: 24, marginRight: 8 }}
                />
                Exportar
              </Button>
              </Box>
          <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            height={"50%"}
            width={"100%"}
            ml={1}
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Buscar"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <IconButton type="button" sx={{ p: 1 }}>
              <SearchIcon />
            </IconButton>
          </Box>
          
        </Box>
      </Box>


      <Box
        display="flex"
        justifyContent="end"
        p={0}
        sx={{ ml: 2, marginBottom: "-3vh" }}
      >
        <Box
          sx={{
            marginRight: "1vh",
            fontSize: "20px",
            color: "rgb(206, 220, 0)",
          }}
        >
          Total:
        </Box>
        <Box
          sx={{
            color: "rgb(255, 255, 255)",
            fontSize: "20px",
          }}
        >
          {isNaN(calcularCantidad()) ? "Error en cálculo" : calcularCantidad()}
        </Box>
        </Box>



      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: colors.greenAccent[300] },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "-1%",
            marginRight: "5px",
          }}
        >

        </Box>
        <DataGrid
          loading={isLoading}
          rows={filteredData}
          columns={columns}
          getRowId={(row, index) =>
            `${row.id}-${index}`
          } // Incluyendo el índice
          // components={{ Toolbar: GridToolbar }}
          components={{ Toolbar: CustomToolbar }}
          // onSelectionModelChange={handleRowSelection}
          selectionModel={selectedRowIds}
          disableMultipleSelection={false}
        />
      </Box>
      <ModalEditWors
        open={modalEditWorks}
        onClose={() => setModalEditWorks(false)}
        onSelectClient={selectedWorks}
      />
      <ModalCharge isLoading={isLoading} />
    </Box>
  );
};

export default ResumenAdelanto;
